<template>
  <div
    v-if="notification"
    class="ToastComponent ToastComponent--show"
    :class="[`ToastComponent--${notification.type}`]"
  >
    <div class="ToastComponent__wrapper">
      <h3 class="ToastComponent__header">
        {{ notification.header }}
      </h3>
      <p class="ToastComponent__body">
        {{ notification.body }}
      </p>
    </div>
    <div class="ToastComponent__close" @click="$emit('close')">
      <div class="icon-close cursor-pointer"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastComponent',
  props: {
    notification: {
      type: Object,
      default: null
    },
    toastStyle: {
      type: String,
      default: 'info'
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close']
}
</script>

<style lang="scss">
.ToastComponent {
  $parent: &;
  width: 300px;
  height: auto;
  border-radius: var(--grid-8);
  align-items: flex-start;
  padding: var(--grid-8);
  display: flex;
  position: relative;
  margin-top: var(--grid-8);
  animation-name: showToast;
  animation-duration: 0.5s;
  animation-delay: 0.4;
  border: 2px solid;

  &__wrapper {
    flex-grow: 1;
  }

  &--info {
    background-color: var(--color-gray-2);
    color: var(--color-primary);
  }

  &--success {
    background-color: var(--color-success-bg);
    color: var(--color-success-text);
  }

  &--danger {
    background-color: var(--color-error-bg);
    color: var(--color-error-text);
  }
}

@keyframes showToast {
  from {
    transform: translateX(-400px);
  }
  to {
    transform: translateX(0);
  }
}
</style>
